// extracted by mini-css-extract-plugin
module.exports = {"VideoEntry":"_2jKvHdhq","videoThumbnail":"_3q3oH-x4","videoStat":"_13YmGrar"};